import { useState, useEffect } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";

/**
 * GET /admin/rewards/ui-catalog — règles machine-readable (champ coupon_type_ids, etc.).
 */
export function useRewardsUiCatalog(brandName) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName) {
            setCatalog(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        loyaltyFetch(`${LOYALTY_API_BASE}/admin/rewards/ui-catalog`, {
            headers: { "X-Brand": brandName },
        })
            .then(async (res) => {
                const data = res.ok ? await res.json().catch(() => null) : null;
                if (!cancelled) setCatalog(data);
            })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName]);

    const createCouponTypeField = catalog?.create?.couponTypeIdsField
        || catalog?.create?.coupon_type_ids
        || null;
    const updateCouponTypeField = catalog?.update?.couponTypeIdsField
        || catalog?.update?.coupon_type_ids
        || createCouponTypeField
        || null;

    const couponTypesOptionsEndpoint = updateCouponTypeField?.optionsEndpoint
        || createCouponTypeField?.optionsEndpoint
        || "/admin/ui-options/coupon-types";

    return {
        catalog,
        createCouponTypeField,
        updateCouponTypeField,
        couponTypesOptionsEndpoint,
        loading,
    };
}
